import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { useSize } from "ahooks";
import ChooseAccount from "./page/ChooseAccount";
import SellAccount from "./page/SellAccount";
import Record from "./page/TradeRecord";
import Collect from "./page/Collect";
import $ from "jquery";
import KeepScroll from "../../lib/KeepScroll";
import { useLogin } from "../../lib/LoginContext";
import useUrlState from "@ahooksjs/use-url-state";

const routeList = [
  {
    id: "chooseAccount",
    text: "选号",
    component: ChooseAccount,
    user: false,
  },
  {
    id: "sellAccount",
    text: "卖号",
    component: SellAccount,
    user: true,
  },
  {
    id: "record",
    text: "记录",
    component: Record,
    user: true,
  },
  {
    id: "notice",
    text: "收藏",
    component: Collect,
    user: true,
  },
];

export default (props) => {
  const [params, setParams] = useUrlState({}, { navigateMode: "replace" });
  const { setShowLogin } = useLogin();

  const routerIndexFromUrl = params?.page != null ? Number(params.page) : 0;
  const [routerIndex, setRouterIndex] = useState(routerIndexFromUrl);

  useEffect(() => {
    if (params?.page != null) {
      setRouterIndex(Number(params.page));
    }
  }, [params?.page]);

  const [swiper, setSwiper] = useState(null);
  useEffect(() => {
    if (swiper) {
      swiper.update();
    }
  }, [props.active, swiper]);
  useEffect(() => {
    if (swiper) {
      swiper.slideTo(routerIndex);
    }
  }, [routerIndex, swiper]);

  const topRef = useRef(null);
  const size = useSize(topRef);

  return (
    <>
      <div className="trade-trades">
        <div className="trade-head width">
          <div className="status-bar-background" />
          <div className="container" ref={topRef}>
            <div className="route-list">
              {routeList.map((item, index) => (
                <div
                  key={item.id}
                  className={`item ${routerIndex === index ? "active" : ""}`}
                  onClick={() => {
                    setParams({
                      ...params,
                      page: "",
                      tab: "",
                      secondTrade: "",
                    });

                    if (
                      item.id !== "chooseAccount" &&
                      !localStorage.getItem("token")
                    ) {
                      setParams({ ...params, keyword: "" });
                      setShowLogin(true);
                      return;
                    }

                    $("html,body").animate({ scrollTop: 0 }, 200);
                    setRouterIndex(index);
                  }}
                >
                  {item.text}
                </div>
              ))}
            </div>

            <div>
              <Link to="/service" className="option service">
                <img src="/resources/four-three/trade/contact.png" alt="" />
              </Link>

              <Link to="/trade/notice" className="option">
                <img src="/resources/four-three/trade/tips.png" alt="" />
              </Link>
            </div>
          </div>
        </div>

        <div className="trade-body">
          {routeList.map((item, index) => (
            <KeepScroll
              key={index}
              active={props.active && routerIndex === index}
              lazy
            >
              <div
                className={
                  "trade-body-item trade-body-" +
                  item.id +
                  " " +
                  (routerIndex === index ? "active" : "")
                }
              >
                <item.component
                  active={props.active && routerIndex === index}
                  size={size}
                />
              </div>
            </KeepScroll>
          ))}
        </div>
      </div>
    </>
  );
};
